<template>
  <div class="form__control">
    <input
      type="hidden"
      ref="input"
      :name="name"
      v-model="token"
    >
    <vue-hcaptcha
      @verify="onVerified"
      @expired="onExpired"
      ref="handler"
      :sitekey="sitekey"
    ></vue-hcaptcha>
  </div>
</template>

<script>
  import VueHcaptcha from '@hcaptcha/vue-hcaptcha';
  export default {
    name: 'support-hcaptcha',
    data: () => ({
      token: "",
    }),
    props: {
      name: String,
      sitekey: String
    },
    components: { VueHcaptcha },
    methods: {
      onVerified: function(token) {
        this.token = token;
        setTimeout(_ => {
          const event = new Event("change");
          this.$refs.input.dispatchEvent(event);
        }, 0);
      },
      onExpired: function() {
        this.token = "";
        setTimeout(_ => {
          const event = new Event("change");
          this.$refs.input.dispatchEvent(event);
        }, 0);
      }
    }
  };
</script>
